import React from 'react';

import ConfigurePage from './configure-page';
import withPage from '../page';
import { derivedPath, derivedSlug } from './routing';

export default withPage(ConfigurePage, {
    wrapperClassName: 'configure-root',
    showWordCloud: true,
    useV2: true,
    useGraphQL: true,
    derivedSlug,
    derivedPath,
    noProps: true,
    shouldNotFetchSlugInfo: (props, prevProps) => {
        let { dir: currentDir, slugTwo: currentSlugTwo } = prevProps.match.params;
        const { match, search } = props;
        const { search: prevSearch } = prevProps;
        let { dir: newDir, slugTwo } = match.params;
        //if on SEO CTO page prevent re-fetching when catEntryId remains the same
        return (
            currentSlugTwo === slugTwo &&
            currentDir === newDir &&
            newDir === 'custom' &&
            search.catEntryId === prevSearch.catEntryId
        );
    },
});
